import React from 'react';
import { Anchor, Box, Button, Text } from 'grommet';
import { ServicePlay } from "grommet-icons"

const Icinga = ({ env, nodename }) => {

    let monitor_url = "https://monitor-int.debesys.net"

    // Set Graphana Host
    if (env.startsWith("ext")) {
        monitor_url = "https://monitor-ext.debesys.net"
    }

    return (
        <Box
            justify="center"
            align="center"
            width="120px"
            margin={{top: '2px'}}
            gap="none"
            background="dark-2"
            alignSelf="center"
            alignContent="center"
            round="xsmall"
        >
            <Anchor alignSelf="center" margin={{ left: "6px", right: "6px" }} href={monitor_url + "/icingaweb2/monitoring/list/services?service_state=0&host=" + nodename + "&showCompact&showFullscreen"} target="_blank">
                <Button plain label={<Text color="white" size="12px" weight="normal">Icinga</Text>} margin={{ top: "xxsmall" }} hoverIndicator={{ color: "light-1", opacity: "weak" }} icon={<ServicePlay size="16px" color="white" />} />
            </Anchor>
        </Box>
    )
}

export default Icinga